import React from "react";
import { PageHero } from "@/components/Section";
import { SEO } from "@/components/SEO";
import { PRESIDENT_IMAGE } from "@/lib/constants";
import { Quote, Users, ShieldCheck, Sprout } from "lucide-react";

const HIGHLIGHTS = [
  { Icon: Users, k: "Proximité", v: "Un engagement de terrain, à l'écoute des communautés et des forces vives." },
  { Icon: Sprout, k: "Conviction", v: "Le développement se construit avec les populations, pas seulement pour elles." },
  { Icon: ShieldCheck, k: "Indépendance", v: "Une démarche citoyenne, libre des schémas partisans traditionnels." },
];

export default function President() {
  return (
    <div data-testid="president-page">
      <SEO title="Le président" description="Seydina Omar Ba, président et fondateur du mouvement DEFAR - Les Bâtisseurs, porte la vision d'une Nation souveraine, juste et spirituellement consciente." />
      <PageHero overline="Le président" title="Mot du président" />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="bg-slate-100 rounded-sm overflow-hidden">
            <img src={PRESIDENT_IMAGE} alt="Seydina Omar Ba" className="w-full aspect-[4/5] object-cover object-top" />
          </div>
          <div className="mt-5 border-l-2 border-brand-green pl-4">
            <p className="font-bold text-lg text-slate-900">Seydina Omar Ba</p>
            <p className="text-sm text-brand-green font-semibold">Président du Mouvement DEFAR – Les Bâtisseurs</p>
          </div>

          <div className="mt-6 space-y-4">
            {HIGHLIGHTS.map(({ Icon, k, v }) => (
              <div key={k} className="flex items-start gap-3 bg-brand-surface p-4 rounded-sm">
                <div className="h-9 w-9 flex items-center justify-center bg-brand-green text-white shrink-0">
                  <Icon size={18} />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wide font-bold text-brand-green">{k}</p>
                  <p className="mt-0.5 text-sm text-slate-700 leading-relaxed">{v}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-brand-green">Engagement</span>
          <h2 className="mt-2 text-2xl font-bold text-slate-900">Bâtir avec et pour les citoyens</h2>

          <div className="mt-6 bg-brand-blue text-white rounded-sm p-7">
            <Quote size={40} className="text-brand-accent" />
            <div className="mt-4 space-y-4 text-lg leading-relaxed">
              <p>
                « Chères concitoyennes, chers concitoyens, c'est avec une profonde conviction que
                je m'adresse à vous au nom du mouvement DEFAR - Les Bâtisseurs.
              </p>
              <p>
                Notre pays regorge de talents, d'énergies et d'espérances. Pourtant, trop de nos
                compatriotes attendent encore que leur potentiel soit reconnu et valorisé. C'est
                pour eux, et avec eux, que nous avons décidé de nous engager.
              </p>
              <p>
                Bâtir, ce n'est pas seulement construire des infrastructures. C'est avant tout
                reconstruire la confiance, restaurer la dignité et redonner espoir à toute une
                nation. C'est l'ambition que nous portons ensemble. »
              </p>
            </div>
            <p className="mt-5 text-sm font-semibold text-brand-accent">— Seydina Omar Ba</p>
          </div>

          <p className="mt-8 text-base font-semibold text-slate-900 italic">
            « Ensemble, chaque voix compte et chaque main est utile : bâtissons le Sénégal que nous méritons. »
          </p>
        </div>
      </section>
    </div>
  );
}
